<template>
<v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
  <v-dialog v-model="permitted_dialog" max-width="400px">
    <v-card>
      <v-card-text>
        <div class="text-center">
          <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
          <p>{{message}}</p>
          <v-progress-circular
            :size="70"
            :width="2"
            :value="100"
            color="error"
            class="mb-4 mr-4"
          >
            <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
          </v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
<v-container v-else v-show="permitted != null" class="pt-0" fluid>
  <v-snackbar
    :value="showMessage()"
    multi-line
    color="#686868"
    top
    
  >
    {{message}}
  </v-snackbar>
  <v-card flat>
  <v-toolbar dense flat color="#2A353D">
    <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Bonds</v-toolbar-title>
    <v-spacer/>
    <span class="white--text caption font-weight-normal mr-3">Currency: {{Currency[0].CurrencyName}}</span>
    <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
  </v-toolbar>
  </v-card>

  <v-data-table
    disable-pagination
    hide-default-footer
    :height="520"
    fixed-header
    :headers="headers"
    :items="confirmedBonds ? Bonds : Bonds.filter(b => b.CheckerID === 0)"
    :search="search"
    sort-by="MakeDate"
    sort-desc
    class="elevation-12 mt-2"
    @current-items="getFiltered"
  >

    <template v-slot:top >
      <v-dialog persistent v-model="rejectionDialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
          </v-card-title>

          <v-card-text>
            <v-select
              filled dense
              v-model="RejectionStatus"
              :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
              item-text="RejectionReasonDescription"
              item-value="RejectionReasonID"
              label="Rejection Reasons"
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('', false); close()">ok</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="deleteDialog" max-width="350px">
        <v-card>
          <v-card-title>
            <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
              <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">yes</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="grey--text subtitle-1 font-weight-normal">Create New Bond</v-toolbar-title>
          <v-spacer/>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
          <v-col class="pt-0">
            <v-row>
              <v-col class="pb-0 pt-0">
                <v-checkbox
                  v-model="bond.def.Prescribed"
                  hide-details
                  class="shrink mt-0 mb-2"
                  label="Prescribed?"
                ></v-checkbox>

                <v-text-field
                  v-model="bond.def.BondNumber"
                  dense filled
                  color="#2A353D"
                  label="Bond Number"
                  required
                  placeholder="----"
                  :rules="[
                    v => !!v || 'field is required',
                    v => (v && v.length <= 25) || 'field must be less than 25 characters'
                  ]"
                ></v-text-field>

                <v-select
                  filled dense
                  v-model="bond.def.IssuerID"
                  :items="allCounterparties.filter(a => a.IsIssuer == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  label="Issuer"
                ></v-select>

                <v-select
                  filled dense
                  @change="getCouponDates(bond.def), getCapitalDates(bond.def)"
                  v-model="bond.def.CouponFrequency"
                  :items="allFrequencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="Frequency"
                  item-value="Months"
                  placeholder="----"
                  label="Interest Frequency"
                ></v-select>

                <v-text-field
                  @input="getMaturityDate(bond.def)"
                  v-model="bond.def.Tenor"
                  light dense filled
                  color="#2A353D"
                  label="Tenor" type="number"
                  placeholder="----"
                ></v-text-field>

                <v-text-field
                  :value="MaturityDate"
                  label="Maturity Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense filled color="#2A353D"
                ></v-text-field>

                <v-text-field
                  @input="getCouponDates(bond.def)"
                  light dense filled
                  color="#2A353D"
                  v-model="bond.def.CouponRate"
                  label="Coupon Rate"
                  placeholder="----"
                  suffix="%"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0">
                <v-checkbox
                  v-model="bond.def.Taxable"
                  hide-details
                  label="Taxable?"
                  class="shrink mt-0 mb-2"
                ></v-checkbox>

                <v-select
                  filled dense
                  v-model="bond.def.BondInvestmentTypeID"
                  :items="allBondInvestmentTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="BondInvestmentTypeDescription"
                  item-value="BondInvestmentTypeID"
                  placeholder="----"
                  label="Investment Type"
                ></v-select>

                <v-text-field
                  :value="bond.def.IssueDate"
                  label="Issue Date"
                  append-icon="mdi-calendar-month"
                  readonly
                  dense filled color="#2A353D"
                ></v-text-field>

                <v-select
                  filled dense
                  v-model="bond.def.CapitalFrequency"
                  :items="CapitalFrequencies"
                  item-text="Frequency"
                  item-value="Months"
                  placeholder="----"
                  label="Capital Frequency"
                ></v-select>

                <v-radio-group row class="my-3" @change="getMaturityDate(bond.def)" v-model="bond.def.TenorInYears" :mandatory="true">
                  <v-radio label="Years" value=1></v-radio>
                  <v-radio label="Months" value=0></v-radio>
                </v-radio-group>

                <v-select
                  filled dense
                  v-model="bond.def.DayCountBasis"
                  :items="DaycountBasis"
                  :item-text="item => item.Basis + ` --> ` + item.BasisDesc"
                  item-value="Basis"
                  placeholder="----"
                  label="DayCount basis"
                ></v-select>

                <v-text-field
                  light dense filled
                  color="#2A353D"
                  v-model="bond.def.TotalValue"
                  label="Total Value"
                  placeholder="----"
                  prefix="$"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="pt-0">
            <v-checkbox
              v-model="bond.def.Listed"
              hide-details
              label="Listed?"
              class="shrink mt-0 mb-2"
            ></v-checkbox>

            <v-tabs
              class="elevation-12"
              fixed-tabs
            >
              <v-tab >Coupon Dates</v-tab>
              <v-tab-item>
                <v-data-table
                  :headers="coupon_dates_headers"
                  :fixed-header="true"
                  :height="240"
                  :items="CouponDates"
                  disable-pagination
                  hide-default-footer
                  class="mb-2"
                >
                </v-data-table>
              </v-tab-item>
              <v-tab >Capital Dates</v-tab>
              <v-tab-item>
                <v-data-table
                  :headers="capital_dates_headers"
                  :fixed-header="true"
                  :height="240"
                  :items="CapitalDates"
                  disable-pagination
                  hide-default-footer
                  class="mb-2"
                >
                </v-data-table>
              </v-tab-item>
            </v-tabs>
            <v-row class="pt-4">
              <v-col class="pb-0 pt-0">
                <v-text-field
                  :value="FirstCouponDate"
                  label="First Coupon Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense filled color="#2A353D"
                ></v-text-field>

                <v-text-field
                  light dense filled
                  color="#2A353D"
                  v-model="bond.def.UnitPrice"
                  label="Conversion"
                  placeholder="----"
                  prefix="$"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0">
                <v-text-field
                  :value="LastCouponDate"
                  label="Last Coupon Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense filled color="#2A353D"
                ></v-text-field>

                <v-text-field
                  v-model="bond.def.TaxRate"
                  :disabled="bond.def.Taxable == true? false: true"
                  light dense filled
                  color="#2A353D"
                  label="Tax Rate"
                  placeholder="----"
                  suffix="%"
                ></v-text-field>
                <div class="text-right mt-7">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="closeCreate()">close</v-btn>
                  <v-btn class="white--text" small color="#2A353D" :disabled="!valid" @click="createNew()">submit</v-btn>          
                </div>
              </v-col>
            </v-row>            
          </v-col>
        </v-row>

      <v-divider class="mt-0"/>
      </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

      <v-form class="edit rounded-t-xl elevation-6" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <v-toolbar dense flat color="#DBEFFA">
          <v-toolbar-title class="d-flex flex-row grey--text subtitle-1 font-weight-normal">Bond: {{currentBond.BondNumber.toUpperCase()}}</v-toolbar-title>
            <v-spacer/>
            <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentBond.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span v-if="currentBond.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentBond.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
            <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentBond.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        </v-toolbar>
        <v-row class="ml-1 mr-1">
          <v-col class="pt-0">
            <v-row>
              <v-col class="pb-0 pt-0">
                <v-checkbox
                  v-model="currentBond.Prescribed"
                  hide-details
                  :readonly="view"
                  class="shrink mt-0 mb-2"
                  label="Prescribed?"
                ></v-checkbox>

                <v-text-field
                  v-model="currentBond.BondNumber"
                  dense filled
                  color="#2A353D"
                  label="Bond Number"
                  required
                  :readonly="view"
                  placeholder="----"
                  :rules="[
                    v => !!v || 'field is required',
                    v => (v && v.length <= 25) || 'field must be less than 25 characters'
                  ]"
                ></v-text-field>

                <v-select
                  filled dense
                  v-model="currentBond.IssuerID"
                  :items="allCounterparties.filter(a => a.IsIssuer == true && a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="CounterPartyName"
                  item-value="CounterPartyID"
                  placeholder="----"
                  :readonly="view"
                  label="Issuer"
                ></v-select>

                <v-select
                  filled dense
                  @change="getCouponDates(currentBond), getCapitalDates(currentBond)"
                  v-model="currentBond.CouponFrequency"
                  :items="allFrequencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="Frequency"
                  item-value="Months"
                  placeholder="----"
                  :readonly="view"
                  label="Interest Frequency"
                ></v-select>

                <v-text-field
                  @input="getMaturityDate(currentBond)"
                  v-model="currentBond.Tenor"
                  light dense filled
                  color="#2A353D"
                  label="Tenor" type="number"
                  :readonly="view"
                  placeholder="----"
                ></v-text-field>

                <v-text-field
                  :value="MaturityDate"
                  label="Maturity Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense filled color="#2A353D"
                ></v-text-field>

                <v-text-field
                  @input="getCouponDates(currentBond)"
                  light dense filled
                  color="#2A353D"
                  v-model="currentBond.CouponRate"
                  label="Coupon Rate"
                  placeholder="----"
                  :readonly="view"
                  suffix="%"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0">
                <v-checkbox
                  v-model="currentBond.Taxable"
                  hide-details
                  label="Taxable?"
                  :readonly="view"
                  class="shrink mt-0 mb-2"
                ></v-checkbox>

                <v-select
                  filled dense
                  v-model="currentBond.BondInvestmentTypeID"
                  :items="allBondInvestmentTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="BondInvestmentTypeDescription"
                  item-value="BondInvestmentTypeID"
                  placeholder="----"
                  :readonly="view"
                  label="Investment Type"
                ></v-select>

                <v-text-field
                  :value="currentBond.IssueDate"
                  label="Issue Date"
                  append-icon="mdi-calendar-month"
                  readonly
                  dense filled color="#2A353D"
                ></v-text-field>

                <v-select
                  filled dense
                  v-model="currentBond.CapitalFrequency"
                  :items="CapitalFrequencies"
                  item-text="Frequency"
                  item-value="Months"
                  placeholder="----"
                  :readonly="view"
                  label="Capital Frequency"
                ></v-select>

                <v-radio-group row class="my-3" :readonly="view" @change="getMaturityDate(currentBond)" v-model="currentBond.TenorInYears" :mandatory="true">
                  <v-radio label="Years" value=1></v-radio>
                  <v-radio label="Months" value=0></v-radio>
                </v-radio-group>

                <v-select
                  filled dense
                  v-model="currentBond.DayCountBasis"
                  :items="DaycountBasis"
                  :item-text="item => item.Basis + ` --> ` + item.BasisDesc"
                  item-value="Basis"
                  placeholder="----"
                  :readonly="view"
                  label="DayCount basis"
                ></v-select>

                <v-text-field
                  light dense filled
                  color="#2A353D"
                  v-model="currentBond.TotalValue"
                  label="Total Value"
                  placeholder="----"
                  :readonly="view"
                  prefix="$"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col class="pt-0">
            <v-checkbox
              v-model="currentBond.Listed"
              hide-details
              label="Listed?"
              :readonly="view"
              class="shrink mt-0 mb-2"
            ></v-checkbox>

            <v-tabs
              class="elevation-12"
              fixed-tabs
            >
              <v-tab >Coupon Dates</v-tab>
              <v-tab-item>
                <v-data-table
                  :headers="coupon_dates_headers"
                  :fixed-header="true"
                  :height="240"
                  :items="CouponDates"
                  disable-pagination
                  hide-default-footer
                  class="mb-2"
                >
                </v-data-table>
              </v-tab-item>
              <v-tab >Capital Dates</v-tab>
              <v-tab-item>
                <v-data-table
                  :headers="capital_dates_headers"
                  :fixed-header="true"
                  :height="240"
                  :items="CapitalDates"
                  disable-pagination
                  hide-default-footer
                  class="mb-2"
                >
                </v-data-table>
              </v-tab-item>
            </v-tabs>
            <v-row class="pt-4">
              <v-col class="pb-0 pt-0">
                <v-text-field
                  :value="FirstCouponDate"
                  label="First Coupon Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense filled color="#2A353D"
                ></v-text-field>

                <v-text-field
                  light dense filled
                  color="#2A353D"
                  v-model="currentBond.UnitPrice"
                  label="Conversion"
                  placeholder="----"
                  :readonly="view"
                  prefix="$"
                ></v-text-field>
              </v-col>
              <v-col class="pb-0 pt-0">
                <v-text-field
                  :value="LastCouponDate"
                  label="Last Coupon Date"
                  append-icon="mdi-calendar-month"
                  readonly placeholder="--/--/--"
                  dense filled color="#2A353D"
                ></v-text-field>

                <v-text-field
                  v-model="currentBond.TaxRate"
                  :disabled="currentBond.Taxable == true? false: true"
                  light dense filled
                  color="#2A353D"
                  label="Tax Rate"
                  placeholder="----"
                  :readonly="view"
                  suffix="%"
                ></v-text-field>
                <div class="text-right mt-7">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
                  <v-btn class="white--text mr-3" v-if="!view" small color="#2A353D" @click="update()">save</v-btn>          
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="mt-0"/>
      </v-form>
      <v-container row>

        <v-text-field
          class="ml-3"
          hide-details
          outlined
          placeholder="search..."
          v-model="search"
          append-icon="mdi-magnify"
          dense
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-btn v-if="showCreateBtn == true" v-show="confirmedBonds" @click="showCreate(); closeEdit(); bond.def.IssueDate = currentSystemDate.DayDate" outlined small color="#2A353D" class="ml-2">
          Create New<v-icon small>mdi-plus</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" v-if="confirmedBonds" outlined small color="#2A353D" class="ml-2">
            EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="generatePDF(false)" text small color="#2A353D">
              <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "xls"
                name    = "Bonds.xls">
  
                <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
              </download-excel>
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn text small color="#2A353D">
              <download-excel
                :data   = "CurrentDataset"
                type    = "csv"
                name    = "Bonds.csv">
  
                <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
              </download-excel>
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn @click="generatePDF(true)" v-if="confirmedBonds" outlined small color="#2A353D" class="ml-2" v-on="on">
          PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
        </v-btn>
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
            CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency)">

          <v-list-item-title>
            {{ Currency.CurrencyName }}
          </v-list-item-title>

          </v-list-item>
          </v-list>
        </v-menu>
        <v-btn v-if="!confirmedBonds" @click="confirmedBonds = true" outlined small color="#2A353D" class="ml-2" v-on="on">
          ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
        </v-btn>
      </v-container>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-tooltip v-if="!confirmedBonds && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="updateStatus(item, true)"
          outlined :disabled="showConfirmBtn == false"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>confirm</span>
      </v-tooltip>
      <v-tooltip v-if="!confirmedBonds && item.CheckerID == 0" top>
        <template v-slot:activator="{ on }">
        <v-btn
          small @click="setActiveBond(item, index); rejectionDialog = true"
          outlined :disabled="showConfirmBtn == false"
          v-on="on"
          color="#2A353D" class="mr-3"
        >
          reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
        </v-btn>
        </template>
        <span>reject</span>
      </v-tooltip>
      <v-btn
        v-show="confirmedBonds"
        small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
        @click="setActiveBond(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>edit</span>
      </v-btn>
      <v-btn
        small outlined
        :disabled="edit"
        @click="view = true; setActiveBond(item, index); showEdit(); closeCreate()"
        color="#2A353D" class="mr-3"
      >
        <span>view</span>
      </v-btn>
      <v-icon
        :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
        color="#2A353D" @click="setActiveBond(item, index); deleteDialog = true"
      >
       mdi-trash-can-outline
      </v-icon>
    </template>

    <template v-slot:item.TotalValue="{ item }">
      {{ Number(item.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
    </template>

    <template v-slot:item.MaturityDate="{ item }">
      {{ item.MaturityDate | moment("DD/MM/YYYY") }}
    </template>

    <template v-slot:item.BondInvestmentTypeID="{ item }">
      {{ allBondInvestmentTypes.filter(a => a.BondInvestmentTypeID == item.BondInvestmentTypeID && a.CheckerID != 0 && a.RejectionID == 0).map(a => a.BondInvestmentTypeDescription)[0] }}
    </template>

    <template v-slot:item.status="{ item }">
      <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
      <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
      <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
    </template>

  </v-data-table>
</v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import administrationService from '../services/administration.service';
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  data () {
    return {
      confirmedBonds: true,
      permitted: null,
      permitted_dialog: true,
      edit: false,
      create: false,
      view: false,
      rejectionDialog: false,
      deleteDialog: false,
      RejectionStatus: 0,
      message: '',
      search: '',
      valid: true,
      currentBond: null,
      currentIndex: -1,
      CurrentDataset: [],
      headers: [
        {
          text: 'Bond Number',
          align: 'start',
          sortable: true,
          value: 'BondNumber'
        },
        { text: 'Bond Investment Type', value: 'BondInvestmentTypeID', sortable: false },
        { text: 'Total Value', value: 'TotalValue', sortable: false },
        { text: 'Maturity Date', value: 'MaturityDate', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      coupon_dates_headers: [
        {
          text: 'Accrue from',
          align: 'start',
          sortable: true,
          value: 'AccrueDate'
        },
        { text: 'Coupon Date', value: 'CouponDate', sortable: false },
        { text: 'Rate(%)', value: 'CouponRate', sortable: false },
        { text: 'Days', value: 'Days', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      capital_dates_headers: [
        {
          text: 'Capital Date',
          align: 'start',
          sortable: true,
          value: 'CapitalDate'
        },
        { text: 'Payment', value: 'Payment', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      CurrencyId: 0,
      MaturityDate: '',
      FirstCouponDate: '',
      LastCouponDate: '',
      CapitalFrequencies: [],
      CouponDates: [],
      CapitalDates: [],
      DaycountBasis: [],
      bond: {
        def: {},
        CapitalDates: [],
        CouponDates: []
      },
      submitted: false,
    }
  },

  computed: {
    ...mapGetters([
      "allBonds",
      "allCurrencies",
      "allApplicationDefaults",
      "allCounterparties",
      "currentSystemDate",
      "allFrequencies",
      "allBondInvestmentTypes",
      "allRejectionReasons",
      "allUsers",
      "allConfirmationSettings"
    ]),
    currentUser() {
      return this.$store.state.auth.user;
    },
    Bonds() {
      return this.allBonds.filter(a => a.CurrencyId == this.CurrencyId);
    },
    Currency() {
      return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
    },
    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 308).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 308).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 308).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 308).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {
    MaturityDate: function() {
      if(this.create == true){
        this.getCouponDates(this.bond.def);
        this.getCapitalDates(this.bond.def)
      } else if(this.edit == true){
        this.getCouponDates(this.currentBond);
        this.getCapitalDates(this.currentBond)
      }
    },

    'bond.def.Taxable': {
      handler: function(newValue) {
        if(newValue == false){
          this.bond.def.TaxRate = 0    
        }
      },
      deep: true
    },

    'currentBond.Taxable': {
      handler: function(newValue) {
        if(newValue == false){
          this.currentBond.TaxRate = 0    
        }
      },
      deep: true
    },
  },

  created(){
    this.CurrencyId = this.allApplicationDefaults[0].CurrencyID;

    administrationService.getCapitalFrequencies()
    .then(response => {
      this.CapitalFrequencies = response.data
    });

    administrationService.getDaycountBasis()
    .then(response => {
      this.DaycountBasis = response.data
    });
  },

  methods: {
    ...mapActions([
      "createBond",
      "updateBondStatus",
      "updateBond",
      "deleteBond"
    ]),

    async createNew() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        this.bond.def.FirstCouponDate = this.FirstCouponDate,
        this.bond.def.LastCouponDate = this.LastCouponDate,
        this.bond.def.MaturityDate = this.MaturityDate,
        this.bond.def.CurrencyId = this.CurrencyId,
        this.bond.def.MakerID = this.currentUser.SecurityUserID,
        this.bond.def.CheckerID = this.CheckerID,
        this.bond.def.LastUserID = this.currentUser.SecurityUserID,

        this.bond.CouponDates = this.CouponDates,
        this.bond.CapitalDates = this.CapitalDates,

        this.createBond(this.bond)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newBond',
            data: response.data
          });
          this.message = response.data.message
          this.closeCreate()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })        
      }
    },

    updateStatus(item, status) {
      this.message = '';
      this.loading = true;

      if(status == true){
        item.CheckerID = this.currentUser.SecurityUserID,
        item.LastUserID = this.currentUser.SecurityUserID,
        item.CheckDate = new Date(),
        item.updatedAt = new Date(),
        item.RejectionID = this.RejectionStatus,
        item.IsConfirmation = status,

        this.updateBondStatus(item)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updBond',
            data: item
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        }) 
      } else {
        this.currentBond.CheckerID = this.currentUser.SecurityUserID,
        this.currentBond.LastUserID = this.currentUser.SecurityUserID,
        this.currentBond.CheckDate = new Date(),
        this.currentBond.updatedAt = new Date(),
        this.currentBond.RejectionID = this.RejectionStatus,
        this.currentBond.IsConfirmation = status,

        this.updateBondStatus(this.currentBond)
        .then(response => {
          this.$socket.client.emit('socketreq', {
            commit: 'updBond',
            data: this.currentBond
          });
          
          this.message = response.data.message
          this.loading = false;
          this.closeEdit()
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
          this.loading = false;
        })        
      }
    },

    async update() {
      this.message = '';
      await this.validate();
      if(this.valid == true){
        if(this.currentBond.CheckerID == 0){

          this.currentBond.FirstCouponDate = this.FirstCouponDate,
          this.currentBond.LastCouponDate = this.LastCouponDate,
          this.currentBond.MaturityDate = this.MaturityDate,
          this.currentBond.CurrencyId = this.CurrencyId,
          this.currentBond.MakerID = this.currentUser.SecurityUserID,
          this.currentBond.CheckerID = 0,
          this.currentBond.CheckDate = null,
          this.currentBond.LastUserID = this.currentUser.SecurityUserID,
          this.currentBond.RejectionID = this.RejectionStatus,

          this.bond.CouponDates = this.CouponDates,
          this.bond.CapitalDates = this.CapitalDates,

          this.updateBond(this.currentBond)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updBond',
              data: this.currentBond
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        } else {
          this.currentBond.FirstCouponDate = this.FirstCouponDate,
          this.currentBond.LastCouponDate = this.LastCouponDate,
          this.currentBond.MaturityDate = this.MaturityDate,
          this.currentBond.CurrencyId = this.CurrencyId,
          this.currentBond.MakerID = this.currentUser.SecurityUserID,
          this.currentBond.MakeDate = new Date(),
          this.currentBond.CheckerID = 0,
          this.currentBond.CheckDate = null,
          this.currentBond.LastUserID = this.currentUser.SecurityUserID,
          this.currentBond.RejectionID = this.RejectionStatus,

          this.bond.CouponDates = this.CouponDates,
          this.bond.CapitalDates = this.CapitalDates,

          this.updateBond(this.currentBond)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updBond',
              data: this.currentBond
            });
            
            this.message = response.data.message
            this.closeEdit()
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        }
      }
    },

    deleteItem() {
      this.message = '';

      this.deleteBond(this.currentBond)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltBond',
          data: this.currentBond
        });
        
        this.message = response.data.message
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
      })
    },

    getMaturityDate(item){
      var data ={
        IssueDate: item.IssueDate,
        Tenor: item.Tenor,
        TenorInYears: item.TenorInYears
      }

      if(item.Tenor != null){
        administrationService.getBondMaturityDate(data)
        .then(response => {
          this.MaturityDate = response.data[0].MaturityDate
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getCouponDates(item){
      var data ={
        IssueDate: item.IssueDate,
        MaturityDate: this.MaturityDate,
        CouponFrequency: item.CouponFrequency,
        CouponRate: item.CouponRate
      }

      if(this.MaturityDate != null && this.MaturityDate != '' && item.CouponFrequency != null && item.CouponRate != null){
        administrationService.getCouponDates(data)
        .then(response => {
          this.CouponDates = response.data;
          this.FirstCouponDate = response.data[0].CouponDate;
          this.LastCouponDate = response.data[response.data.length -1].CouponDate;
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    getCapitalDates(item){
      var data ={
        IssueDate: item.IssueDate,
        MaturityDate: this.MaturityDate,
        CouponFrequency: item.CouponFrequency
      }

      if(this.MaturityDate != null && this.MaturityDate != '' && item.CouponFrequency != null){
        administrationService.getCapitalDates(data)
        .then(response => {
          this.CapitalDates = response.data
        },
        error => {
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        })
      }
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Bonds", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Bonds.pdf')
      }
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    mapCurrency(currency) {
      return this.CurrencyId = currency.CurrencyID
    },

    unconfirmed() {
      this.confirmedBonds = false
    },

    showEdit () {
      this.edit = true
    },

    closeEdit() {
      this.bond.def = {},
      this.bond.CapitalDates = [],
      this.bond.CouponDates = [],
      this.CapitalDates = [],
      this.CouponDates = [],
      this.MaturityDate = '',
      this.FirstCouponDate = '',
      this.LastCouponDate = '',
      this.edit = false
    },

    showCreate () {
      this.create = true
    },

    closeCreate() {
      this.bond.def = {},
      this.bond.CapitalDates = [],
      this.bond.CouponDates = [],
      this.CapitalDates = [],
      this.CouponDates = [],
      this.MaturityDate = '',
      this.FirstCouponDate = '',
      this.LastCouponDate = '',
      this.create = false
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    validate () {
      this.$refs.form.validate()
    },

    reset () {
      this.$refs.form.reset()
    },

    close () {
      this.rejectionDialog = false
      this.RejectionStatus = 0
    },

    setActiveBond (item, index) {
      this.getMaturityDate(item)

      this.currentBond = item
      this.currentIndex = index
    },
  },

  mounted () {
    UserService.isBonds().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("unconfirmedBonds", () => {
      this.unconfirmed();
    });
  }
}
</script>

<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

.v-btn {
  outline: none
}

.edit {
  background-color: #DBEFFA;
}

.headline {
  color:white
}
</style>
